// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateOrganizationPricingRuleDTO
 */
export interface UpdateOrganizationPricingRuleDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationPricingRuleDTO
     */
    pricingRule: UpdateOrganizationPricingRuleDTOPricingRuleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateOrganizationPricingRuleDTOPricingRuleEnum {
    STANDARD = 'STANDARD',
    STANDARDCAP250 = 'STANDARD_CAP_250',
    STANDARDCAP300 = 'STANDARD_CAP_300',
    STANDARDCAP350 = 'STANDARD_CAP_350',
    NOMINALPERTENANT = 'NOMINAL_PER_TENANT',
    STANDARD15PERCENTDISCOUNT = 'STANDARD_15_PERCENT_DISCOUNT'
}



